export default "__VITE_ASSET__CmN3PK8o__"